module.exports = __webpack_public_path__ + "img/biotekno-logo.5359cc36.png";